import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";
import fomImg from "../img/FOM_logo.jpg";
import wccImg from "../img/wcc-logo-text.png";
// import mccImg from "../img/MCC_Logo_RGB_NoTag-h100.png";


const About = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>About</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        Porchfest is a <a href="https://fomwps.wixsite.com/winchester-music" target="_blank"
                                          rel="noreferrer">Friends of
                        Music</a> initiative, organized and run by local volunteers, and funded in part by a grant from
                        the <a href="https://winchesterculturalcouncil.org/" target="_blank" rel="noreferrer">Winchester
                        Cultural Council</a>.
                        {/*and the <a href="https://massculturalcouncil.org/" target="_blank"*/}
                        {/*                                rel="noreferrer">Mass Cultural Council</a>.*/}
                    </Col>
                </Row>
                <br/>
                <Row className="mb-3">
                    <Col>
                        <a href="https://fomwps.wixsite.com/winchester-music" target="_blank" rel="noreferrer"
                           className="about-sponsor">
                            <img src={fomImg} alt="Winchester Friends of Music"/>
                        </a>
                        <a href="https://winchesterculturalcouncil.org" target="_blank" rel="noreferrer"
                           className="about-sponsor">
                            <img src={wccImg} alt="Winchester Cultural Council"/>
                        </a>
                        {/*<a href="https://massculturalcouncil.org" target="_blank" rel="noreferrer" className="about-sponsor">*/}
                        {/*    <img src={mccImg} alt="Mass Cultural Council"/>*/}
                        {/*</a>*/}
                    </Col>
                </Row>
                <br/>
                <Row className="mb-3">
                    <Col>
                        <p>Your Winchester Porchfest Committee, aka "The Porch Stars":</p>

                        <ul>
                            <li>Fred Yen (Winchester Farmers Market)</li>
                            <li>Laurie Russell (Winchester Community Music School)</li>
                            <li>Shukong Ou and Peter Pulsifer (Winchester Cultural Council)</li>
                            <li>
                                Salma Abounadi, Gina Altaras, Shelley Ayervais, Kaleem Baba, Omar Baba, Debbie Catalano, Catherine
                                Curtis, Keith Doo, Susan Rozmanith (Members)
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        {/*TODO: picture*/}
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default About;
